/**
 * Volta V3 — paylaşılan etkileşimler.
 * Mevcut theme.js / cart.js ile çakışmaz: yalnızca data-v3-* seçicileri.
 */
(function () {
  'use strict';

  var BOUND = 'data-v3-bound';
  var COMPARE_KEY = 'v3-compare';
  var VIEW_KEY = 'v3-plp-view';
  var scrollLocks = 0;

  function qs(root, sel) { return (root || document).querySelector(sel); }
  function qsa(root, sel) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function mark(el) {
    if (!el || el.getAttribute(BOUND) === '1') return false;
    el.setAttribute(BOUND, '1');
    return true;
  }
  function on(el, ev, fn, opts) {
    if (!el) return;
    el.addEventListener(ev, fn, opts || false);
  }

  function lockScroll() {
    scrollLocks += 1;
    document.body.classList.add('v3-scroll-lock');
  }
  function unlockScroll() {
    scrollLocks = Math.max(0, scrollLocks - 1);
    if (!scrollLocks) document.body.classList.remove('v3-scroll-lock');
  }

  function focusables(root) {
    return qsa(root, 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')
      .filter(function (el) { return el.offsetParent !== null || el === document.activeElement; });
  }

  function trapFocus(root, e) {
    if (e.key !== 'Tab') return;
    var list = focusables(root);
    if (!list.length) return;
    var first = list[0];
    var last = list[list.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function moneyDec(cents) {
    var n = Number(cents || 0) / 100;
    return n.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function chipMonths() {
    var el = document.getElementById('volta-installment-config');
    var months = [3, 6];
    if (!el) return months;
    try {
      var raw = JSON.parse(el.textContent || '{}');
      var parsed = String(raw.chipMonths || '')
        .split(',')
        .map(function (s) { return parseInt(s.trim(), 10); })
        .filter(function (n) { return n > 1; });
      if (parsed.length) months = parsed;
    } catch (err) { /* yut */ }
    return months;
  }

  /* ---- Akordeon ---- */
  function bindAccordions(root) {
    qsa(root, '[data-v3-acc]').forEach(function (group) {
      if (!mark(group)) return;
      var single = group.hasAttribute('data-v3-acc-single');
      qsa(group, '.v3-acc__head').forEach(function (btn) {
        on(btn, 'click', function () {
          var expanded = btn.getAttribute('aria-expanded') === 'true';
          var panel = document.getElementById(btn.getAttribute('aria-controls')) || btn.nextElementSibling;
          if (single) {
            qsa(group, '.v3-acc__head').forEach(function (other) {
              if (other === btn) return;
              other.setAttribute('aria-expanded', 'false');
              var op = document.getElementById(other.getAttribute('aria-controls')) || other.nextElementSibling;
              if (op) {
                op.hidden = true;
                op.classList.remove('is-open');
              }
              var oi = other.closest('.v3-acc__item');
              if (oi) oi.classList.remove('is-open');
            });
          }
          btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
          if (panel) {
            panel.hidden = expanded;
            panel.classList.toggle('is-open', !expanded);
          }
          var item = btn.closest('.v3-acc__item');
          if (item) item.classList.toggle('is-open', !expanded);
        });
      });
    });
  }

  /* ---- Sekmeler ---- */
  function bindTabs(root) {
    qsa(root, '[data-v3-tabs]').forEach(function (wrap) {
      if (!mark(wrap)) return;
      on(wrap, 'click', function (e) {
        var tab = e.target.closest('[data-v3-tab]');
        if (!tab || !wrap.contains(tab)) return;
        e.preventDefault();
        var id = tab.getAttribute('data-v3-tab');
        qsa(wrap, '[data-v3-tab]').forEach(function (t) {
          var onTab = t === tab;
          t.classList.toggle('is-active', onTab);
          t.setAttribute('aria-selected', onTab ? 'true' : 'false');
        });
        qsa(wrap, '[data-v3-panel]').forEach(function (p) {
          var show = p.getAttribute('data-v3-panel') === id;
          p.hidden = !show;
        });
      });
    });
  }

  /* ---- Sürüklemeli yatay slider ---- */
  function bindDrag(root) {
    var DRAG_THRESHOLD = 5;
    qsa(root, '[data-v3-drag]').forEach(function (track) {
      if (!mark(track)) return;
      var down = false;
      var dragging = false;
      var startX = 0;
      var startScroll = 0;
      var pointerId = null;

      on(track, 'pointerdown', function (e) {
        if (e.pointerType === 'touch') return;
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        down = true;
        dragging = false;
        startX = e.clientX;
        startScroll = track.scrollLeft;
        pointerId = e.pointerId;
      });

      on(track, 'pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        if (!dragging && Math.abs(dx) >= DRAG_THRESHOLD) {
          dragging = true;
          track.classList.add('is-dragging');
          try { track.setPointerCapture(e.pointerId); } catch (err) { /* yut */ }
        }
        if (dragging) track.scrollLeft = startScroll - dx;
      });

      function end() {
        if (!down) return;
        down = false;
        if (pointerId != null) {
          try { track.releasePointerCapture(pointerId); } catch (err) { /* yut */ }
        }
        pointerId = null;
        track.classList.remove('is-dragging');
      }

      on(track, 'pointerup', end);
      on(track, 'pointercancel', function () {
        end();
        dragging = false;
      });

      on(track, 'click', function (e) {
        if (!dragging) return;
        e.preventDefault();
        e.stopPropagation();
        dragging = false;
      }, true);
    });
  }

  /* ---- PDP galeri + lightbox ---- */
  function bindGallery(root) {
    qsa(root, '[data-v3-gallery]').forEach(function (gallery) {
      if (!mark(gallery)) return;
      var main = qs(gallery, '[data-v3-gallery-main]');
      var thumbs = qsa(gallery, '[data-v3-gallery-thumb]');
      var zoom = qs(gallery, '[data-v3-gallery-zoom]');
      var index = 0;

      function srcOf(el) {
        return el.getAttribute('data-src') || (el.querySelector('img') && el.querySelector('img').getAttribute('src')) || '';
      }
      function zoomOf(el) {
        return el.getAttribute('data-zoom') || srcOf(el);
      }
      function setIndex(i) {
        if (!thumbs.length) return;
        index = (i + thumbs.length) % thumbs.length;
        thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === index); });
        if (main) {
          var img = main.tagName === 'IMG' ? main : qs(main, 'img');
          var src = srcOf(thumbs[index]);
          if (img && src) img.setAttribute('src', src);
        }
        qsa(gallery, '[data-v3-gallery-dot]').forEach(function (d, n) {
          d.classList.toggle('is-active', n === index);
        });
      }

      thumbs.forEach(function (t, i) {
        on(t, 'click', function () { setIndex(i); });
      });
      qsa(gallery, '[data-v3-gallery-dot]').forEach(function (d, i) {
        on(d, 'click', function () { setIndex(i); });
      });

      var swipe = qs(gallery, '[data-v3-gallery-swipe]');
      if (swipe) {
        var sx = 0;
        on(swipe, 'touchstart', function (e) { sx = e.changedTouches[0].clientX; }, { passive: true });
        on(swipe, 'touchend', function (e) {
          var dx = e.changedTouches[0].clientX - sx;
          if (Math.abs(dx) > 40) setIndex(index + (dx < 0 ? 1 : -1));
        });
      }

      var lightbox = null;
      function closeLb() {
        if (!lightbox) return;
        lightbox.hidden = true;
        unlockScroll();
        if (zoom) zoom.focus();
      }
      function openLb() {
        if (!lightbox) {
          lightbox = document.createElement('div');
          lightbox.className = 'v3-lightbox';
          lightbox.setAttribute('role', 'dialog');
          lightbox.setAttribute('aria-modal', 'true');
          lightbox.innerHTML =
            '<button type="button" class="v3-lightbox__close" data-v3-lb-close aria-label="Kapat"></button>' +
            '<button type="button" class="v3-lightbox__nav v3-lightbox__prev" data-v3-lb-prev aria-label="Önceki"></button>' +
            '<img alt="" data-v3-lb-img>' +
            '<button type="button" class="v3-lightbox__nav v3-lightbox__next" data-v3-lb-next aria-label="Sonraki"></button>';
          document.body.appendChild(lightbox);
          qs(lightbox, '[data-v3-lb-close]').innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75"><path d="M6 6l12 12M18 6L6 18"/></svg>';
          qs(lightbox, '[data-v3-lb-prev]').innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75"><path d="M14.5 6l-6 6 6 6"/></svg>';
          qs(lightbox, '[data-v3-lb-next]').innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75"><path d="M9.5 6l6 6-6 6"/></svg>';
          on(lightbox, 'click', function (e) {
            if (e.target === lightbox || e.target.closest('[data-v3-lb-close]')) closeLb();
            if (e.target.closest('[data-v3-lb-prev]')) { setIndex(index - 1); paintLb(); }
            if (e.target.closest('[data-v3-lb-next]')) { setIndex(index + 1); paintLb(); }
          });
          on(lightbox, 'keydown', function (e) {
            if (e.key === 'Escape') closeLb();
            if (e.key === 'ArrowLeft') { setIndex(index - 1); paintLb(); }
            if (e.key === 'ArrowRight') { setIndex(index + 1); paintLb(); }
            trapFocus(lightbox, e);
          });
        }
        paintLb();
        lightbox.hidden = false;
        lockScroll();
        qs(lightbox, '[data-v3-lb-close]').focus();
      }
      function paintLb() {
        if (!lightbox) return;
        var img = qs(lightbox, '[data-v3-lb-img]');
        var src = thumbs[index] ? zoomOf(thumbs[index]) : (main && (main.getAttribute('data-zoom') || main.getAttribute('src')));
        if (img && src) img.setAttribute('src', src);
      }
      if (zoom) on(zoom, 'click', openLb);
    });
  }

  /* ---- Adet sayacı ---- */
  function bindQty(root) {
    qsa(root, '[data-v3-qty]').forEach(function (wrap) {
      if (!mark(wrap)) return;
      var input = qs(wrap, '[data-v3-qty-input]') || qs(wrap, 'input');
      if (!input) return;
      var min = parseInt(input.getAttribute('min') || '1', 10);
      var max = parseInt(input.getAttribute('max') || '999', 10);
      function set(n) {
        n = Math.max(min, Math.min(max, n));
        input.value = String(n);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      on(qs(wrap, '[data-v3-qty-minus]'), 'click', function () { set((parseInt(input.value, 10) || 1) - 1); });
      on(qs(wrap, '[data-v3-qty-plus]'), 'click', function () { set((parseInt(input.value, 10) || 1) + 1); });
      on(input, 'input', function () {
        var n = parseInt(input.value, 10);
        if (!n || n < min) input.value = String(min);
      });
    });
  }

  /* ---- Model bulucu ---- */
  function bindModelFinder(root) {
    qsa(root, '[data-v3-finder]').forEach(function (form) {
      if (!mark(form)) return;
      var selects = qsa(form, '[data-v3-finder-select]');
      var btn = qs(form, '[data-v3-finder-go]');
      function refresh() {
        var filled = selects.every(function (s) { return s.value; });
        if (btn) {
          btn.classList.toggle('is-disabled', !filled);
          btn.disabled = !filled;
        }
      }
      selects.forEach(function (s) { on(s, 'change', refresh); });
      refresh();
      on(form, 'submit', function (e) {
        e.preventDefault();
        var empty = selects.filter(function (s) { return !s.value; })[0];
        if (empty) { empty.focus(); return; }
        var urls = selects.map(function (s) { return s.value; }).filter(Boolean);
        var target = urls[0];
        try {
          var base = new URL(target, window.location.origin);
          urls.slice(1).forEach(function (u) {
            var extra = new URL(u, window.location.origin);
            extra.searchParams.forEach(function (v, k) { base.searchParams.set(k, v); });
          });
          window.location.assign(base.pathname + base.search);
        } catch (err) {
          window.location.assign(target);
        }
      });
    });
  }

  /* ---- Yedek parça bulucu (bağımlı select) ---- */
  function bindPartsFinder(root) {
    qsa(root, '[data-v3-parts]').forEach(function (box) {
      if (!mark(box)) return;
      var group = qs(box, '[data-v3-parts-group]');
      var model = qs(box, '[data-v3-parts-model]');
      var btn = qs(box, '[data-v3-parts-go]');
      if (!group || !model) return;

      function fillModels() {
        var opt = group.options[group.selectedIndex];
        var raw = (opt && opt.getAttribute('data-models')) || '[]';
        var list = [];
        try { list = JSON.parse(raw); } catch (err) { list = []; }
        var placeholder = model.getAttribute('data-placeholder') || 'Model seçin';
        model.innerHTML = '';
        var first = document.createElement('option');
        first.value = '';
        first.textContent = placeholder;
        model.appendChild(first);
        list.forEach(function (item) {
          var o = document.createElement('option');
          o.value = item.handle || item.url || '';
          o.textContent = item.label || item.title || item.handle || '';
          model.appendChild(o);
        });
        model.disabled = !list.length;
        if (btn) btn.disabled = true;
      }
      on(group, 'change', fillModels);
      on(model, 'change', function () {
        if (btn) btn.disabled = !model.value;
      });
      on(box, 'submit', function (e) {
        e.preventDefault();
        if (!model.value) { model.focus(); return; }
        var handle = model.value;
        if (handle.indexOf('/') === 0 || handle.indexOf('http') === 0) {
          window.location.assign(handle);
        } else {
          window.location.assign('/collections/' + handle);
        }
      });
      if (btn) on(btn, 'click', function (e) {
        if (btn.tagName === 'BUTTON' && box.tagName !== 'FORM') {
          e.preventDefault();
          if (!model.value) { model.focus(); return; }
          var handle = model.value;
          window.location.assign(handle.indexOf('/') === 0 ? handle : '/collections/' + handle);
        }
      });
    });
  }

  /* ---- Karşılaştırma ---- */
  function readCompare() {
    try { return JSON.parse(sessionStorage.getItem(COMPARE_KEY) || '[]'); } catch (err) { return []; }
  }
  function writeCompare(list) {
    sessionStorage.setItem(COMPARE_KEY, JSON.stringify(list));
    document.dispatchEvent(new CustomEvent('v3:compare-change', { detail: list }));
    paintCompareButtons(list);
  }
  function paintCompareButtons(list) {
    var n = (list || readCompare()).length;
    qsa(document, '[data-v3-compare-start]').forEach(function (btn) {
      var base = btn.getAttribute('data-label') || 'Karşılaştırmayı başlat';
      btn.textContent = n >= 2 ? (btn.getAttribute('data-label-n') || 'Karşılaştır') + ' (' + n + ')' : base;
      btn.disabled = n < 2;
      btn.classList.toggle('is-disabled', n < 2);
    });
    qsa(document, '[data-v3-compare]').forEach(function (input) {
      var id = String(input.getAttribute('data-id') || '');
      input.checked = (list || readCompare()).some(function (item) { return String(item.id) === id; });
    });
  }
  function bindCompare(root) {
    qsa(root, '[data-v3-compare]').forEach(function (input) {
      if (!mark(input)) return;
      on(input, 'change', function () {
        var list = readCompare();
        var item = {
          id: input.getAttribute('data-id'),
          title: input.getAttribute('data-title') || '',
          url: input.getAttribute('data-url') || '',
          image: input.getAttribute('data-image') || '',
          price: input.getAttribute('data-price') || '',
          motor: input.getAttribute('data-motor') || '',
          tags: input.getAttribute('data-tags') || ''
        };
        if (input.checked) {
          if (!list.some(function (x) { return String(x.id) === String(item.id); })) list.push(item);
        } else {
          list = list.filter(function (x) { return String(x.id) !== String(item.id); });
        }
        writeCompare(list);
      });
    });
    qsa(root, '[data-v3-compare-start]').forEach(function (btn) {
      if (!mark(btn)) return;
      on(btn, 'click', function () {
        var list = readCompare();
        if (list.length < 2) return;
        openCompareModal(list);
      });
    });
    paintCompareButtons();
  }
  var compareModal;
  function openCompareModal(list) {
    if (!compareModal) {
      compareModal = document.createElement('div');
      compareModal.className = 'v3-modal';
      compareModal.setAttribute('role', 'dialog');
      compareModal.setAttribute('aria-modal', 'true');
      compareModal.innerHTML = '<div class="v3-modal__backdrop" data-v3-modal-close></div><div class="v3-modal__panel" role="document"><button type="button" class="v3-btn v3-btn--outline" data-v3-modal-close style="float:right;min-height:36px;padding:0 12px">Kapat</button><div data-v3-compare-body></div></div>';
      document.body.appendChild(compareModal);
      on(compareModal, 'click', function (e) {
        if (e.target.closest('[data-v3-modal-close]')) closeCompareModal();
      });
      on(compareModal, 'keydown', function (e) {
        if (e.key === 'Escape') closeCompareModal();
        trapFocus(compareModal, e);
      });
    }
    var body = qs(compareModal, '[data-v3-compare-body]');
    var head = '<tr><th></th>' + list.map(function (i) {
      return '<th><a href="' + (i.url || '#') + '">' + (i.title || '') + '</a></th>';
    }).join('') + '</tr>';
    var rows = [
      ['Görsel', list.map(function (i) { return i.image ? '<img src="' + i.image + '" alt="" width="120" height="90">' : ''; })],
      ['Fiyat', list.map(function (i) { return i.price || '—'; })],
      ['Motor', list.map(function (i) { return i.motor || '—'; })],
      ['Özellikler', list.map(function (i) { return i.tags || '—'; })]
    ].map(function (row) {
      return '<tr><th>' + row[0] + '</th>' + row[1].map(function (c) { return '<td>' + c + '</td>'; }).join('') + '</tr>';
    }).join('');
    body.innerHTML = '<table class="v3-modal__table"><thead>' + head + '</thead><tbody>' + rows + '</tbody></table>';
    compareModal.hidden = false;
    lockScroll();
    qs(compareModal, '[data-v3-modal-close]').focus();
  }
  function closeCompareModal() {
    if (!compareModal) return;
    compareModal.hidden = true;
    unlockScroll();
  }

  /* ---- PLP istemci filtre motoru ---- */
  function bindFilters(root) {
    qsa(root, '[data-v3-filters]').forEach(function (box) {
      if (!mark(box)) return;
      var scope = box.closest('[data-v3-plp]') || document;
      var cards = function () { return qsa(scope, '[data-v3-card]'); };

      function apply() {
        var stock = qsa(box, '[data-v3-filter="available"]:checked').map(function (el) { return el.value; });
        var altkat = qsa(box, '[data-v3-filter="altkat"]:checked').map(function (el) { return el.value; });
        var motor = qsa(box, '[data-v3-filter="motor"]:checked').map(function (el) { return el.value; });
        var tags = qsa(box, '[data-v3-filter="tag"]:checked').map(function (el) { return el.value; });
        var minEl = qs(box, '[data-v3-filter-min]');
        var maxEl = qs(box, '[data-v3-filter-max]');
        var min = minEl && minEl.value ? parseFloat(minEl.value) : null;
        var max = maxEl && maxEl.value ? parseFloat(maxEl.value) : null;
        var visible = 0;
        cards().forEach(function (card) {
          var ok = true;
          var avail = card.getAttribute('data-available') === 'true';
          var price = parseFloat(card.getAttribute('data-price') || '0');
          var ak = card.getAttribute('data-altkat') || '';
          var mot = card.getAttribute('data-motor') || '';
          var tg = (card.getAttribute('data-tags') || '').split('|');
          if (stock.length) {
            if (stock.indexOf('1') !== -1 && stock.indexOf('0') === -1) ok = ok && avail;
            if (stock.indexOf('0') !== -1 && stock.indexOf('1') === -1) ok = ok && !avail;
          }
          if (min != null && !isNaN(min)) ok = ok && price >= min;
          if (max != null && !isNaN(max)) ok = ok && price <= max;
          if (altkat.length) ok = ok && altkat.indexOf(ak) !== -1;
          if (motor.length) ok = ok && motor.indexOf(mot) !== -1;
          if (tags.length) ok = ok && tags.some(function (t) { return tg.indexOf(t) !== -1; });
          card.hidden = !ok;
          if (ok) visible += 1;
        });
        qsa(scope, '[data-v3-filter-count]').forEach(function (el) { el.textContent = String(visible); });
        var clear = qs(box, '[data-v3-filter-clear]');
        var active = stock.length + altkat.length + motor.length + tags.length + (min != null ? 1 : 0) + (max != null ? 1 : 0);
        if (clear) clear.hidden = active === 0;
        paintActive(box, scope);
      }

      function paintActive(src, scopeEl) {
        var host = qs(scopeEl, '[data-v3-activefilters]');
        if (!host) return;
        host.innerHTML = '';
        qsa(src, '[data-v3-filter]:checked, [data-v3-filter-min], [data-v3-filter-max]').forEach(function (el) {
          if (el.type === 'number' || el.type === 'text') {
            if (!el.value) return;
          }
          var label = el.getAttribute('data-label') || el.value || el.name;
          var chip = document.createElement('span');
          chip.className = 'v3-activefilter';
          chip.innerHTML = '<span></span><button type="button" aria-label="Kaldır">×</button>';
          chip.querySelector('span').textContent = label + (el.value && el.type !== 'checkbox' ? ': ' + el.value : '');
          on(chip.querySelector('button'), 'click', function () {
            if (el.type === 'checkbox') el.checked = false;
            else el.value = '';
            apply();
          });
          host.appendChild(chip);
        });
      }

      on(box, 'change', apply);
      on(box, 'input', function (e) {
        if (e.target.matches('[data-v3-filter-min], [data-v3-filter-max]')) apply();
      });
      var clearBtn = qs(box, '[data-v3-filter-clear]');
      if (clearBtn) on(clearBtn, 'click', function () {
        qsa(box, '[data-v3-filter]').forEach(function (el) { el.checked = false; });
        qsa(box, '[data-v3-filter-min], [data-v3-filter-max]').forEach(function (el) { el.value = ''; });
        apply();
      });

      qsa(box, '[data-v3-filter-group] .v3-filters__group-title').forEach(function (btn) {
        on(btn, 'click', function () {
          var open = btn.getAttribute('aria-expanded') !== 'true';
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
          var panel = document.getElementById(btn.getAttribute('aria-controls')) || btn.nextElementSibling;
          if (panel) panel.hidden = !open;
        });
      });
    });

    qsa(root, '[data-v3-view]').forEach(function (btn) {
      if (!mark(btn)) return;
      on(btn, 'click', function () {
        var mode = btn.getAttribute('data-v3-view');
        try { localStorage.setItem(VIEW_KEY, mode); } catch (err) { /* yut */ }
        var grid = qs(document, '[data-v3-product-grid]');
        if (grid) grid.classList.toggle('is-list', mode === 'list');
        qsa(document, '[data-v3-view]').forEach(function (b) {
          b.classList.toggle('is-active', b.getAttribute('data-v3-view') === mode);
        });
      });
    });
    try {
      var saved = localStorage.getItem(VIEW_KEY);
      if (saved) {
        var grid = qs(root, '[data-v3-product-grid]') || qs(document, '[data-v3-product-grid]');
        if (grid) grid.classList.toggle('is-list', saved === 'list');
        qsa(document, '[data-v3-view]').forEach(function (b) {
          b.classList.toggle('is-active', b.getAttribute('data-v3-view') === saved);
        });
      }
    } catch (err) { /* yut */ }

    qsa(root, '[data-v3-sort]').forEach(function (sel) {
      if (!mark(sel)) return;
      on(sel, 'change', function () {
        var grid = qs(document, '[data-v3-product-grid]');
        if (!grid) return;
        var items = qsa(grid, '[data-v3-card]').filter(function (c) { return !c.hidden; });
        items.sort(function (a, b) {
          var pa = parseFloat(a.getAttribute('data-price') || '0');
          var pb = parseFloat(b.getAttribute('data-price') || '0');
          var ta = (a.getAttribute('data-title') || '').toLocaleLowerCase('tr');
          var tb = (b.getAttribute('data-title') || '').toLocaleLowerCase('tr');
          var ia = parseInt(a.getAttribute('data-product-id') || '0', 10);
          var ib = parseInt(b.getAttribute('data-product-id') || '0', 10);
          switch (sel.value) {
            case 'price-asc': return pa - pb;
            case 'price-desc': return pb - pa;
            case 'title': return ta.localeCompare(tb, 'tr');
            case 'newest': return ib - ia;
            default: return 0;
          }
        });
        items.forEach(function (el) { grid.appendChild(el); });
      });
    });
  }

  /* ---- YouTube facade ---- */
  function bindYoutube(root) {
    qsa(root, '[data-v3-yt]').forEach(function (btn) {
      if (!mark(btn)) return;
      on(btn, 'click', function () {
        var id = btn.getAttribute('data-v3-yt') || btn.getAttribute('data-video-id');
        if (!id) return;
        var host = btn.closest('[data-v3-yt-facade]') || btn.parentElement;
        var iframe = document.createElement('iframe');
        iframe.setAttribute('src', 'https://www.youtube.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0');
        iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
        iframe.setAttribute('allowfullscreen', '');
        iframe.setAttribute('title', btn.getAttribute('data-title') || 'Video');
        host.innerHTML = '';
        host.appendChild(iframe);
      });
    });
  }

  /* ---- Mega menü ---- */
  function bindMegaMenu(root) {
    qsa(root, '[data-v3-mega]').forEach(function (item) {
      if (!mark(item)) return;
      var trigger = qs(item, '[data-v3-mega-trigger]');
      var panel = qs(item, '[data-v3-mega-panel]');
      if (!trigger || !panel) return;
      var leaveTimer;
      function open() {
        clearTimeout(leaveTimer);
        trigger.setAttribute('aria-expanded', 'true');
        panel.classList.add('is-open');
      }
      function close() {
        trigger.setAttribute('aria-expanded', 'false');
        panel.classList.remove('is-open');
      }
      on(item, 'mouseenter', open);
      on(item, 'mouseleave', function () { leaveTimer = setTimeout(close, 160); });
      on(trigger, 'click', function (e) {
        if (window.matchMedia('(min-width: 992px)').matches) {
          e.preventDefault();
          if (trigger.getAttribute('aria-expanded') === 'true') close();
          else open();
        }
      });
      on(trigger, 'keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'ArrowDown') {
          e.preventDefault();
          open();
          var first = qs(panel, 'a');
          if (first) first.focus();
        }
        if (e.key === 'Escape') close();
      });
      on(panel, 'keydown', function (e) {
        if (e.key === 'Escape') { close(); trigger.focus(); }
      });
      on(document, 'keydown', function (e) {
        if (e.key === 'Escape') close();
      });
    });
  }

  /* ---- Mobil çekmece ---- */
  function bindDrawer(root) {
    qsa(root, '[data-v3-drawer-open]').forEach(function (btn) {
      if (!mark(btn)) return;
      on(btn, 'click', function (e) {
        e.preventDefault();
        var id = btn.getAttribute('data-v3-drawer-open');
        var drawer = document.getElementById(id) || qs(document, '[data-v3-drawer="' + id + '"]');
        if (drawer) openDrawer(drawer, btn);
      });
    });
    qsa(root, '[data-v3-drawer]').forEach(function (drawer) {
      if (!mark(drawer)) return;
      qsa(drawer, '[data-v3-drawer-close]').forEach(function (btn) {
        on(btn, 'click', function () { closeDrawer(drawer); });
      });
      var backdrop = qs(drawer, '[data-v3-drawer-backdrop]');
      if (backdrop) on(backdrop, 'click', function () { closeDrawer(drawer); });
      on(drawer, 'keydown', function (e) {
        if (e.key === 'Escape') closeDrawer(drawer);
        if (drawer.classList.contains('is-open')) trapFocus(drawer, e);
      });
    });
  }
  function openDrawer(drawer, trigger) {
    drawer.classList.add('is-open');
    drawer.removeAttribute('hidden');
    drawer.setAttribute('data-v3-opener', trigger && trigger.id ? trigger.id : '');
    lockScroll();
    var first = focusables(drawer)[0];
    if (first) first.focus();
  }
  function closeDrawer(drawer) {
    drawer.classList.remove('is-open');
    unlockScroll();
    var opener = drawer.getAttribute('data-v3-opener');
    if (opener) {
      var btn = document.getElementById(opener);
      if (btn) btn.focus();
    }
  }

  /* ---- Header sticky gölge ---- */
  function bindHeader(root) {
    qsa(root, '[data-v3-header]').forEach(function (header) {
      if (!mark(header)) return;
      function onScroll() {
        header.classList.toggle('is-stuck', window.scrollY > 120);
      }
      on(window, 'scroll', onScroll, { passive: true });
      onScroll();
    });
  }

  /* ---- Wishlistr favori butonu ----
     Uygulama butonu <nav> içine enjekte ediyor; nav mutlak konumlu ve ortalandığı için
     sonradan gelen 24px menüyü kaydırıyor. Butonu ikon grubuna taşıyoruz. */
  function moveWishlistButton() {
    var tools = qs(document, '.v3-header__tools');
    var btn = document.getElementById('wishlistr-header-btn');
    if (!tools || !btn || btn.parentElement === tools) return;
    btn.style.marginLeft = '';
    btn.style.marginRight = '';
    var burger = qs(tools, '.v3-header__burger');
    tools.insertBefore(btn, burger || null);
  }

  function bindWishlistRelocate() {
    var nav = qs(document, '.v3-header__nav');
    if (!nav || !mark(nav)) return;
    moveWishlistButton();
    if (!window.MutationObserver) return;
    new MutationObserver(moveWishlistButton).observe(nav, { childList: true });
  }

  /* ---- Kart swatch (V3 ek alanları) ---- */
  function bindCardSwatch(root) {
    qsa(root, '[data-v3-card]').forEach(function (card) {
      if (!mark(card)) return;
      on(card, 'click', function (e) {
        var sw = e.target.closest('[data-card-swatch]');
        if (!sw || !card.contains(sw)) return;
        var price = parseInt(sw.getAttribute('data-swatch-price'), 10) || 0;
        var compare = parseInt(sw.getAttribute('data-swatch-compare'), 10) || 0;
        var available = sw.getAttribute('data-swatch-available') !== 'false';
        var onSale = compare > price;
        card.setAttribute('data-available', available ? 'true' : 'false');
        card.setAttribute('data-price', String(price / 100));
        var inst = qs(card, '[data-v3-inst]');
        if (inst && price) {
          var months = parseInt(inst.getAttribute('data-months') || '3', 10);
          var per = price / months;
          var style = inst.getAttribute('data-style') || 'line';
          if (style === 'monthly') {
            var all = chipMonths();
            var maxM = Math.max.apply(null, all);
            inst.textContent = (inst.getAttribute('data-template') || "Aylık {amount} TL'den başlayan taksitlerle")
              .replace('{amount}', moneyDec(price / maxM));
          } else {
            inst.textContent = (inst.getAttribute('data-template') || '{months} x {amount} TL taksitle')
              .replace('{months}', String(months))
              .replace('{amount}', moneyDec(per));
          }
        }
        var priceNow = qs(card, '[data-card-price-new]');
        if (priceNow && price) {
          var nowSpan = qs(priceNow, 'span');
          if (nowSpan) nowSpan.textContent = (price / 100).toLocaleString('tr-TR', { maximumFractionDigits: 0 });
          priceNow.classList.toggle('is-sale', onSale);
        }
        var priceOld = qs(card, '[data-card-price-old]');
        if (priceOld) {
          priceOld.hidden = !onSale;
          if (onSale) {
            var oldSpan = qs(priceOld, 'span');
            if (oldSpan) oldSpan.textContent = (compare / 100).toLocaleString('tr-TR', { maximumFractionDigits: 0 });
          }
        }
        var saleBadge = qs(card, '[data-card-sale]');
        if (saleBadge) {
          saleBadge.hidden = !(onSale && available);
          var discEl = qs(saleBadge, '[data-card-disc]');
          if (discEl && onSale && compare) {
            discEl.textContent = '%' + Math.round(((compare - price) * 100) / compare) + ' indirim';
          }
        }
        var stock = qs(card, '[data-card-stock]');
        if (stock) {
          stock.hidden = !available;
          stock.classList.toggle('v3-badge--right', available && onSale);
          stock.classList.toggle('v3-badge--left', !(available && onSale));
        }
        var cta = qs(card, '[data-v3-card-cta]');
        if (cta) {
          var dest = sw.getAttribute('data-swatch-url') || cta.getAttribute('href');
          if (dest) cta.setAttribute('href', dest);
          if (available) {
            cta.className = 'v3-btn v3-btn--lime v3-btn--block';
            cta.textContent = cta.getAttribute('data-label-view') || 'İncele';
          } else {
            cta.className = 'v3-btn v3-btn--outline v3-btn--block';
            cta.textContent = cta.getAttribute('data-label-notify') || 'Stok gelince haber ver';
          }
        }
      });
    });
  }

  function bindNotify(root) {
    qsa(root, '[data-v3-notify]').forEach(function (el) {
      if (!mark(el)) return;
      on(el, 'click', function (e) {
        if (el.getAttribute('href') && el.getAttribute('href') !== '#') return;
        e.preventDefault();
        var card = el.closest('[data-v3-card]');
        var dest = (card && (card.getAttribute('data-url') || (qs(card, '[data-card-link]') || {}).href)) || el.getAttribute('data-notify-url');
        if (dest) window.location.assign(dest);
      });
    });
  }

  function init(root) {
    root = root || document;
    bindAccordions(root);
    bindTabs(root);
    bindDrag(root);
    bindGallery(root);
    bindQty(root);
    bindModelFinder(root);
    bindPartsFinder(root);
    bindCompare(root);
    bindFilters(root);
    bindYoutube(root);
    bindMegaMenu(root);
    bindDrawer(root);
    bindHeader(root);
    bindWishlistRelocate();
    bindCardSwatch(root);
    bindNotify(root);
  }

  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
